import { I18n } from 'react-redux-i18n';
import { IColumnData } from '../models/table/columnData';

export const FRANCHISE_API_PATH = 'Franchise';

const ViewListPath = 'franchises.page.view.list';
const InputPath = 'franchises.page.input';

export const franchiseHeaders = {
  NAME: `${ViewListPath}.name`,
  TYPE: `${ViewListPath}.type`,
  PRIORITY: `${ViewListPath}.priority`
};

export const franchiseColumns = {
  NAME: 'name',
  TYPE: 'type',
  PRIORITY: 'priority'
};

export const franchiseDefaultOrderBy = {
  path: 'createdAtLocal',
  order: 'desc' as const
};

export const franchisesAvailableFiltersKeys: string[] = [
  franchiseColumns.TYPE,
  franchiseColumns.PRIORITY
];

export const getFranchiseHubUrl = (item: any) => {
  return `/hub/${item.id}`;
};

const formatEnumLabel = (i18nPrefix: string) => (value: string) => {
  if (!value) return '';
  const key = `${i18nPrefix}.${value}.label`;
  const translated = I18n.t(key);
  // Fall back to the raw value if the i18n lookup fails (renders as the literal key).
  return translated === key ? value : translated;
};

// Editions column removed: the Franchise search API will no longer return the
// `editions` field in list responses going forward, so a count column here
// would always render as 0.
export const franchiseColumnData: IColumnData[] = [
  {
    header: franchiseHeaders.NAME,
    path: franchiseColumns.NAME,
    defaultVisible: true
  },
  {
    header: franchiseHeaders.TYPE,
    path: franchiseColumns.TYPE,
    defaultVisible: true,
    customFormatter: formatEnumLabel(`${InputPath}.type.options`)
  },
  {
    header: franchiseHeaders.PRIORITY,
    path: franchiseColumns.PRIORITY,
    defaultVisible: true,
    customFormatter: formatEnumLabel(`${InputPath}.priority.options`)
  }
];
